
export enum BatchFrameworkArgumentTypeCd {
	ARGUMENT = 'Argument',
	CONFIG = 'Config'}
